
// Get the appropriate consumption label based on telemetry type
export const getConsumptionLabel = (telemetryType: 'energy' | 'gas' | 'water') => {
  switch (telemetryType) {
    case 'gas':
      return 'Gas Consumption (m³/h)';
    case 'water':
      return 'Water Consumption (L/h)';
    default:
      return 'Power Consumption (W)';
  }
};

// Get the appropriate color based on telemetry type
export const getUtilityColor = (telemetryType: 'energy' | 'gas' | 'water') => {
  switch (telemetryType) {
    case 'gas':
      return '#f59e0b'; // amber
    case 'water':
      return '#0ea5e9'; // sky blue
    default:
      return '#10b981'; // green
  }
};

// Get border color class based on telemetry type
export const getBorderColorClass = (telemetryType: 'energy' | 'gas' | 'water') => {
  return telemetryType === 'gas' 
    ? 'border-amber-500 ring-amber-500' 
    : telemetryType === 'water' 
      ? 'border-sky-500 ring-sky-500' 
      : 'border-emerald-500 ring-emerald-500';
};

// Get tooltip style for charts
export const getTooltipStyle = () => {
  return { 
    borderRadius: '8px', 
    border: 'none', 
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' 
  };
};

// Format device ID for display
export const formatDeviceId = (deviceId: string) => {
  return deviceId.toUpperCase();
};

// Get severity class based on alarm level
export const getSeverityClass = (severity: string) => {
  switch (severity.toLowerCase()) {
    case 'critical':
    case 'high':
      return 'text-red-500';
    case 'warning':
    case 'medium':
      return 'text-amber-500';
    case 'low':
      return 'text-emerald-500';
    default:
      return 'text-gray-500';
  }
};
